import { CognitoUserPool, CognitoUserSession } from "amazon-cognito-identity-js";

const userId = {
  UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
  ClientId: process.env.GATSBY_COGNITO_CLIENT_ID,
};

if (!userId.ClientId || !userId.UserPoolId) {
  console.error('This user not found');
}

export function getCognitoUser() {
  const poolId = new CognitoUserPool(userId);
  return poolId.getCurrentUser();
}

export function getSessionPromise(): Promise<CognitoUserSession> {
  return new Promise((resolve, reject) => {
    const cognitoUser = getCognitoUser();

    if (!cognitoUser) {
      reject(new Error('User not authenticated'));
      return;
    }

    cognitoUser.getSession((err, session) => {
      if (session) {
        resolve(session);
      } else {
        reject(err || 'Session is null');
      }
    });
  });
}
